import Item from './Item.component'

export default Item
